// Common
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Modules
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AttachmentsModule } from '@modules/attachments/attachments.module';
import { CalendarAppModule } from '@modules/calendar-app/calendar-app.module';
import { ContactsModule } from '@modules/contacts/contacts.module';
import { ElementsModule } from '@modules/elements/elements.module';
import { FilesModule } from '@modules/files/files.module';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { KnotsModule } from '@modules/knots/knots.module';
import { MessagesModule } from '@modules/messages/messages.module';
import { NotesModule } from '@modules/notes/notes.module';
import { SheetsModule } from '@modules/sheets/sheets.module';
import { SplitViewModule } from '@modules/split-view/split-view.module';
import { TasksModule } from '@modules/tasks/tasks.module';
import { UtilsModule } from '@modules/utils/utils.module';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { PagesModule } from '../pages/pages.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';

// Directives
import { ModalHostDirective } from './directives/modal-host.directive';

// Components
import { CalendarAppContextDirective } from '@modules/calendar-app/directives/app-calendar-app-context.directive';
import { ContactsAppContextDirective } from '@modules/contacts/directives/app-contacts-app-context.directive';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { FilesAppContextDirective } from '@modules/files/directives/app-files-app-context.directive';
import { MatIconModule } from '@angular/material/icon';
import { TooltipDirective } from '@modules/tooltip/tooltip.directive';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { NotesAppContextDirective } from '@modules/notes/directives/app-notes-app-context.directive';
import { SheetsAppContextDirective } from '@modules/sheets/directives/app-sheets-app-context.directive';
import { TaskingAppContextDirective } from '@modules/tasks/directives/app-tasking-app-context.directive';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { FullFormModalComponent } from './components/full-form-modal/full-form-modal.component';
import { MessageComposeDialogComponent } from './components/message-compose/message-compose-dialog.component';
import { ModalWrapperComponent } from './components/modal-wrapper/modal-wrapper.component';

@NgModule({
  imports: [
    AppCommonModule,
    AttachmentsModule,
    CalendarAppModule,
    CommonModule,
    ContactsModule,
    DragDropModule,
    ElementsModule,
    FilesModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    TooltipDirective,
    MessagesModule,
    NotesModule,
    SheetsModule,
    PagesModule,
    ReactiveFormsModule,
    RouterModule,
    SplitViewModule,
    TasksModule,
    UserAvatarModule,
    UtilsModule,
    LinkedInfoListComponent,
    MailAppContextDirective,
    CalendarAppContextDirective,
    TaskingAppContextDirective,
    NotesAppContextDirective,
    SheetsAppContextDirective,
    ContactsAppContextDirective,
    FilesAppContextDirective,
  ],
  exports: [BaseModalComponent, MessageComposeDialogComponent, ModalHostDirective, ModalWrapperComponent],
  declarations: [
    BaseModalComponent,
    FullFormModalComponent,
    MessageComposeDialogComponent,
    ModalHostDirective,
    ModalWrapperComponent,
  ],
  providers: [],
})
export class ModalModule {}
